import { BrowserModule } from "@angular/platform-browser"
import { NgModule, LOCALE_ID, Injector } from "@angular/core"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { AppRoutingModule } from "./app-routing.module"
import { AppComponent } from "./app.component"
import { PagesModule } from "./components/pages/pages.module"
import { CommonModule, registerLocaleData } from "@angular/common"
import localeIt from "@angular/common/locales/it"
import { RouterModule } from "@angular/router"
import { AgmCoreModule } from "@agm/core"
import { environment } from "../environments/environment"
import { HttpClientModule, HttpClient } from "@angular/common/http"
import { ToastrModule } from "ngx-toastr"
import { HelpersService } from "./services/helpers.service"
import { TranslateModule, TranslateLoader } from "@ngx-translate/core"
import { TranslateHttpLoader } from "@ngx-translate/http-loader"
import { ServiceLocator } from "./services/locator.service"

registerLocaleData(localeIt)

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json")
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		RouterModule,
		BrowserModule,
		BrowserAnimationsModule,
		CommonModule,
		HttpClientModule,
		AppRoutingModule,
		PagesModule,
		AgmCoreModule.forRoot({
			apiKey: environment.API_GOOGLE
		}),
		ToastrModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		})
	],
	exports: [RouterModule],
	providers: [HelpersService, ServiceLocator, { provide: LOCALE_ID, useValue: "it-IT" }],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private injector: Injector) {
		ServiceLocator.injector = this.injector
	}
}
